import React from 'react'
import { Trans } from '@lingui/react'
import CenterBox from './CenterBox.js'

const HomePage = () => (
  <CenterBox>
    <Trans>
      <h2>Not found</h2>
      <p>The page you are looking for does no longer exist.</p>
    </Trans>
  </CenterBox>
)

export default HomePage



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js